import { Box, styled } from "@mui/material"

export const FullContainer = styled(Box)(({ theme }) => ({
    position: "fixed",
    width: "100vw",
    height: "100vh",
    overflow: "hidden",
    pointerEvents: "none",
    "& > *": {
        pointerEvents: "auto",
    }
}))